import { breakpointKeys, cascadeBreakpointKeys } from '../constants/breakpoints';

const getResolveTargets = (targets, cascade) =>
  Object.entries(targets).reduce((acc, [target, breakpointBasedValue]) => {
    const resolvedBreakpointKey = cascade.find(
      (breakpointKey) => breakpointBasedValue?.[breakpointKey] !== undefined
    );

    if (resolvedBreakpointKey !== undefined) {
      acc[target] = breakpointBasedValue[resolvedBreakpointKey];
    }

    return acc;
  }, {});

const getResolvedState = (state, activeBreakpointKey) => {
  const cascade =
    cascadeBreakpointKeys[activeBreakpointKey] || cascadeBreakpointKeys[breakpointKeys.DEFAULT];

  return Object.entries(state).reduce((acc, [elementId, targets]) => {
    const resolvedTargets = getResolveTargets(targets, cascade);

    if (Object.keys(resolvedTargets).length) {
      acc[elementId] = resolvedTargets;
    }

    return acc;
  }, {});
};

export default getResolvedState;
